const STORAGE_KEY = 'edugen_lead_source';

// Reads utm_source off the current URL (Google/Meta ad links, campaign
// links, etc. all tag this) and remembers it for the rest of the browser
// session, so a multi-step signup flow (land on an ad link -> browse ->
// fill the popup form later) still attributes to the source that actually
// brought the visitor in, not whatever page they happen to submit from.
export function captureLeadSource() {
  try {
    const utmSource = new URLSearchParams(window.location.search).get('utm_source');
    if (utmSource && utmSource.trim()) {
      sessionStorage.setItem(STORAGE_KEY, utmSource.trim());
      return utmSource.trim();
    }
  } catch (_) {
    // sessionStorage/URL access can throw in locked-down contexts — fall
    // through to whatever was already captured, if anything.
  }
  return getStoredLeadSource();
}

export function getStoredLeadSource() {
  try {
    return sessionStorage.getItem(STORAGE_KEY) || '';
  } catch (_) {
    return '';
  }
}
